import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // v1.9.2: Aggressive freshness for live SEO data.
      // - staleTime 15s: Cache short, so navigation between pages shows fresh numbers
      // - refetchOnMount 'always': Every page mount triggers a refetch (fixes stale UI bug)
      // - refetchOnWindowFocus true: Returning to tab refreshes data
      staleTime: 15_000,
      refetchOnMount: "always",
      refetchOnWindowFocus: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
